import slugify from '../src/slugify';
export default slugify;
